import React, { Component } from 'react'

import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import Wikipedia from './Wikipedia'

class GlossaryCard extends Component {
    render() {
        if (!this.props.glossary || this.props.glossary.length === 0) return null
        return (
            <Card id="glossary" className="mx-2 my-2">
                <CardHeader className="py-2 px-4 border-b">
                    <CardTitle className="text-sm font-medium">Glossary</CardTitle>
                </CardHeader>
                <CardContent className="px-4 py-2">
                    { this.props.glossary.map(item => {
                        return <Wikipedia key={ item.pageId } title={ item.title } pageId={ item.pageId } />
                    })}
                </CardContent>
            </Card>
        )
    }
}

export default GlossaryCard
